import { Project } from 'mdello-client-ts/dist/src/interfaces/common/project.interface';
import { useMutation } from 'react-query';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { useNotification } from 'src/providers/notificationsProvider';
import { UseMutationInterface } from 'src/reactQuery/customers/mutations/interfaces/useUpdateCustomer.interface';
import { downloadContent } from 'src/services/napi';

const downloadContentFile = async () => {
  const currentProject: Project | undefined = getDataFromLocalStorage(
    LocalStorageKey.CURRENT_PROJECT
  );
  if (!currentProject) return;

  const response = await downloadContent(currentProject._id);

  // @ts-ignore
  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'stations.xlsx');
  document.body.appendChild(link);
  link.click();
};

export const useDownloadFile = ({ onError, onSuccess }: UseMutationInterface) => {
  const { notify } = useNotification();

  return useMutation(() => downloadContentFile(), {
    onError: () => {
      notify({ message: 'something went wrong', severity: 'error' });
      if (onError) {
        onError();
      }
    },
    onSuccess: () => {
      if (onSuccess) {
        onSuccess();
      }
    }
  });
};
